var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order && _vm.content
    ? _c(
        "div",
        { staticClass: "final-review" },
        [
          _vm.loading
            ? _c("Spinner", {
                attrs: { name: "circle", color: "var(--color-links)" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.cartExpired
            ? _c("div", { staticClass: "container" }, [
                _c("p", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.content.checkoutExpiredHeader ||
                          "Sorry, but due to inactivity and for your security, your cart has expired"
                      ) +
                      "\n    "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "button button--primary",
                    attrs: { href: "/" },
                  },
                  [_vm._v(" Leave checkout ")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.cartExpired
            ? _c("section", { staticClass: "checkout" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "checkout--content" }, [
                    _c("fieldset", [
                      _c("legend", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.content.orderSummaryLabel || "Order Summary"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "summary" }, [
                        _c("div", { staticClass: "summary--header" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.content.currencyLabel || "Currency")
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.content.amountLabel || "Amount")),
                          ]),
                          _vm._v(" "),
                          _vm.showLoyaltyCTA && _vm.isSignedInToLoyalty
                            ? _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.content.loyaltyRateLabel ||
                                        "Loyalty Rate"
                                    ) +
                                    "\n              "
                                ),
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.content.standardRateLabel || "Rate"
                                    ) +
                                    "\n              "
                                ),
                              ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm.order.product.id !== _vm.ProductTypes.SELL_BACK
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.content.priceLabel || "Price")
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.content.amountFromSellbackLabel ||
                                        "You'll get"
                                    )
                                  ),
                                ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "summary--items" },
                          [
                            _vm._l(_vm.order.lines, function (line, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "summary--item" },
                                [
                                  _c("div", [
                                    _c("span", {
                                      class:
                                        "icon icon__" +
                                        line.currency.code.toLowerCase(),
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "code" }, [
                                      _vm._v(_vm._s(line.currency.code)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(line.qty))]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm._f("rate")(line.rate))),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm._f("price")(line.total))),
                                  ]),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.COMMERCE_SHOW_BUYBACK &&
                            _vm.order.buyBackGuarantee
                              ? _c("div", { staticClass: "summary--buyback" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.content.buybackGuaranteeLabel ||
                                          "Buyback Guarantee"
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(_vm._f("price")(4)))]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.COMMERCE_SHOW_REFUND &&
                            _vm.order.refundGuarantee
                              ? _c("div", { staticClass: "summary--buyback" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.content.refundGuaranteeLabel ||
                                          "Refund Guarantee"
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(_vm._f("price")(3)))]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "summary--buyback" }, [
                              _vm.order.product.id ===
                              _vm.ProductTypes.HOME_DELIVERY
                                ? _c("label", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.content.homeDeliveryLabel ||
                                            "Standard delivery"
                                        ) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order.product.id ===
                              _vm.ProductTypes.CLICK_AND_COLLECT
                                ? _c("label", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.content.clickAndCollectLabel ||
                                            "Branch collection"
                                        ) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order.product.id ===
                              _vm.ProductTypes.SELL_BACK
                                ? _c("label", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.content.sellbackAndCollectLabel ||
                                            "Sell back and collect"
                                        ) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm._f("price")(
                                        _vm.order.deliverySlot.price
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "summary--total" }, [
                              _vm.order.product.id !==
                              _vm.ProductTypes.SELL_BACK
                                ? _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.content.totalAmountToPayLabel ||
                                          "Total to pay"
                                      )
                                    ),
                                  ])
                                : _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.content
                                          .totalAmountFromSellbackLabel ||
                                          "Total you will receive"
                                      )
                                    ),
                                  ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "total-price" }, [
                                _vm._v(
                                  _vm._s(_vm._f("price")(_vm.order.total))
                                ),
                              ]),
                            ]),
                          ],
                          2
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("fieldset", [
                      _c("legend", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.content.deliveryMethodLabel ||
                                "Delivery Method"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.order.state.value === _vm.OrderStates.CREATED
                          ? _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    return _vm.navigate(
                                      "checkout-select-delivery-slot"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.content.amendDetailsLinkText ||
                                      "Amend my details"
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grid" }, [
                        _c("div", [
                          _vm.order.product.id ===
                          _vm.ProductTypes.HOME_DELIVERY
                            ? _c(
                                "div",
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.content.homeDeliveryLabel ||
                                            "Delivery Address"
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("delivery-address", {
                                    attrs: { order: _vm.order },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.content.clickAndCollectLabel ||
                                            "Collection Address"
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("store-address", {
                                    attrs: { storeAddress: _vm.storeAddress },
                                  }),
                                ],
                                1
                              ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm.order.product.id ===
                          _vm.ProductTypes.HOME_DELIVERY
                            ? _c("div", [
                                _c("label", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.content.deliveryDateLabel ||
                                          "Delivery date"
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("date")(
                                        _vm.order.deliverySlot.date
                                      )
                                    )
                                  ),
                                ]),
                              ])
                            : _c("div", [
                                _c("label", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.content.collectionDateLabel ||
                                          "Collection date"
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("date")(
                                        _vm.order.deliverySlot.date
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("fieldset", [
                      _c("legend", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.content.contactDetailsLabel ||
                                "Contact Details"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.order.state.value === _vm.OrderStates.CREATED
                          ? _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    return _vm.navigate(
                                      "checkout-customer-information",
                                      "contact-details"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.content.amendDetailsLinkText ||
                                      "Amend my details"
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grid" }, [
                        _c("div", [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.content.emailAddressLabel || "Email address"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.order.customer.email))]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.content.phoneNumberLabel || "Phone number"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.order.customer.phoneNumber) +
                                "\n              "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("fieldset", [
                      _c("legend", [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.content.aboutYouLabel || "About You")
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.order.state.value === _vm.OrderStates.CREATED
                          ? _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    return _vm.navigate(
                                      "checkout-customer-information",
                                      "about-you"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.content.amendDetailsLinkText ||
                                      "Amend my details"
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grid" }, [
                        _c("div", [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.content.firstNameLabel || "First name")
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.order.customer.firstName)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.content.lastNameLabel || "Last name")
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.order.customer.lastName)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.content.dateOfBirthLabel || "Date of birth"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                new Date(
                                  _vm.order.customer.dateOfBirth
                                ).toLocaleDateString()
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("fieldset", [
                      _c("legend", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.content.billingAddressLabel ||
                                "Billing Address"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.order.state.value === _vm.OrderStates.CREATED
                          ? _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    return _vm.navigate(
                                      "checkout-customer-information",
                                      "billing-address"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.content.amendDetailsLinkText ||
                                      "Amend my details"
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grid" }, [
                        _c(
                          "div",
                          [
                            _c("customer-address", {
                              attrs: { order: _vm.order },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "final-review--next" },
                      [
                        _vm.loading
                          ? _c("Spinner", {
                              attrs: {
                                name: "circle",
                                color: "var(--color-links)",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.loading
                          ? _c(
                              "button",
                              {
                                staticClass: "button button--primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.next()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.content.nextButtonLabel || "Next"
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.loading &&
                        _vm.devicePayEnabled &&
                        _vm.order.product.id !== _vm.ProductTypes.SELL_BACK
                          ? _c("div", [
                              _vm._m(0),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "pay-buttons" },
                                [
                                  _c("ApplePayWidget", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.applePay.isEnabled &&
                                          _vm.showApplePay,
                                        expression:
                                          "applePay.isEnabled && showApplePay",
                                      },
                                    ],
                                    attrs: {
                                      amount: String(_vm.order.total),
                                      merchantIdentifier:
                                        _vm.applePay.merchantId,
                                      merchantName: _vm.applePay.merchantName,
                                      currencyCode: _vm.applePay.currencyCode,
                                      countryCode: _vm.applePay.countryCode,
                                      acceptCreditCards: _vm.acceptCreditCards,
                                    },
                                    on: {
                                      available: function ($event) {
                                        _vm.showApplePay = $event
                                      },
                                      success: _vm.handleSuccess,
                                      error: _vm.handleError,
                                      cancel: _vm.handleCancel,
                                      confirmOrder: _vm.onConfirmOrder,
                                      "3ds": _vm.onThreeDSRedirect,
                                      click: _vm.disablePayButtons,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("GooglePayWidget", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.googlePay.isEnabled &&
                                          _vm.showGooglePay,
                                        expression:
                                          "googlePay.isEnabled && showGooglePay",
                                      },
                                    ],
                                    attrs: {
                                      environment: _vm.googlePay.productionMode
                                        ? "PRODUCTION"
                                        : "TEST",
                                      amount: String(_vm.order.total),
                                      currencyCode: _vm.googlePay.currencyCode,
                                      countryCode: _vm.googlePay.countryCode,
                                      acceptCreditCards: _vm.acceptCreditCards,
                                      merchantId: _vm.googlePay.merchantId,
                                      merchantName: _vm.googlePay.merchantName,
                                      gatewayMerchant:
                                        _vm.googlePay.gatewayMerchant,
                                      gatewayMerchantId:
                                        _vm.googlePay.gatewayMerchantId,
                                    },
                                    on: {
                                      available: function ($event) {
                                        _vm.showGooglePay = $event
                                      },
                                      success: _vm.handleSuccess,
                                      error: _vm.handleError,
                                      cancel: _vm.handleCancel,
                                      "3ds": _vm.onThreeDSRedirect,
                                      confirmOrder: _vm.onConfirmOrder,
                                      click: _vm.disablePayButtons,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("ThreeDSModal", {
                                    attrs: {
                                      url: _vm.threeDSUrl,
                                      visible: _vm.threeDSVisible,
                                    },
                                    on: {
                                      close: _vm.onThreeDSClose,
                                      complete: _vm.onThreeDSComplete,
                                      failed: _vm.onThreeDSFailed,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.paymentProcessing
                                    ? _c("div", { staticClass: "tds-overlay" })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pay-divider" }, [
      _c("span", [_vm._v("or")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }